/* Smooth-scroll only — hero autoplay runs inline in vibe-home.liquid */
(function () {
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function headerOffset() {
    const sticky = document.querySelector('sticky-header');
    if (sticky) return sticky.offsetHeight + 16;
    const header = document.querySelector('.section-header') || document.querySelector('header');
    return (header ? header.offsetHeight : 0) + 16;
  }

  function pageScroller() {
    const el = document.getElementById('AcPageScroll');
    if (!el || !window.matchMedia('(max-width: 989px)').matches) return null;
    const overflowY = getComputedStyle(el).overflowY;
    if (overflowY !== 'auto' && overflowY !== 'scroll') return null;
    return el;
  }

  function currentScroll() {
    const el = pageScroller();
    return el ? el.scrollTop : window.scrollY;
  }

  function setScroll(y) {
    const el = pageScroller();
    if (el) el.scrollTop = y;
    else window.scrollTo(0, y);
  }

  function targetScrollTop(target) {
    const el = pageScroller();
    if (el) {
      return target.getBoundingClientRect().top - el.getBoundingClientRect().top + el.scrollTop;
    }
    return target.getBoundingClientRect().top + window.scrollY - headerOffset();
  }

  function smoothScrollTo(target) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      setScroll(targetScrollTop(target));
      return;
    }

    const start = currentScroll();
    const initialDistance = targetScrollTop(target) - start;
    if (Math.abs(initialDistance) < 2) return;

    const duration = Math.min(1100, Math.max(480, Math.abs(initialDistance) * 0.55));
    let startTime = null;

    function frame(now) {
      if (startTime == null) startTime = now;
      const progress = Math.min(1, (now - startTime) / duration);
      const destination = targetScrollTop(target);
      setScroll(start + (destination - start) * easeInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        setScroll(targetScrollTop(target));
        window.setTimeout(function () {
          setScroll(targetScrollTop(target));
        }, 380);
      }
    }

    requestAnimationFrame(frame);
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-vibe-smooth-scroll]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    const target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', href);
    smoothScrollTo(target);
  });

  /* Theme editor / section reload only — normal pages use inline kick */
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector?.('[data-vibe-home]') || event.target;
    if (!root || !root.hasAttribute || !root.hasAttribute('data-vibe-home')) return;
    const video = root.querySelector('[data-vibe-hero-video]');
    if (!video) return;
    video.muted = true;
    video.volume = 0;
    const p = video.play();
    if (p && typeof p.then === 'function') p.catch(function () {});
  });
})();
